var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMinus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#E02020",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M8 14.667H24V17.334H8z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMinus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/minus.f69ecb1e.svg";
export { ForwardRef as ReactComponent };